import { render, staticRenderFns } from "./consulting02.vue?vue&type=template&id=d8be49ce&scoped=true&"
import script from "./consulting02.vue?vue&type=script&lang=js&"
export * from "./consulting02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8be49ce",
  null
  
)

export default component.exports